import { HttpClient } from '@angular/common/http';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { catchError, map, Observable, of } from 'rxjs';

@Pipe({
  name: "svg",
})
export class SvgPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer, private http: HttpClient) { }




  transform(url: string): string | Observable<SafeHtml> {
    if (!url) {
      return '';
    }
    return this.http.get(url, { responseType: 'text' }).pipe(
      map((svgContent: any) => svgContent ? this.sanitizer.bypassSecurityTrustHtml(svgContent) : ''),
      catchError(() => of(''))
    );
  }
}
